<div class="file-upload">
    <input type="file" #fileInput [attr.accept]="allowedFileTypes" (change)="onFilesSelected($event)" />    
</div>